import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class LicenseSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
